<template>
  <div>
    <div class="vx-col w-full mb-base">
      <vs-card title="Add New location" class="p-4 mb-6">
        <div slot="header" class="flex flex-wrap items-center justify-between">
          <div class="flex items-center">
            <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
            <h4 style="margin-left: 10px">Add New location</h4>
          </div>
          <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm">Save</vs-button>
        </div>
        <div class="vx-row mt-6">
          <div class="vx-col md:w-1/4 w-full">
            <!-- <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input class="w-full" disabled label="Location ID " v-model="data.id" />
              </div>
            </div> -->
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input class="w-full" label="Location Code *" v-model="data.location_code" />
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label for class="vs-input--label">Location Type *</label>
                <vs-select
                    class="selectExample"
                    v-model="data.location_type_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, location_type)"
                >
                    <vs-select-item v-for="(item, index) in location_type.data" :key="index" :value="item.id" :text="item.code"/>
                </vs-select>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label for class="vs-input--label">Dedicated Product</label>
                <vs-select
                    class="selectExample"
                    v-model="data.dedicated_product_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, product)"
                >
                    <vs-select-item v-for="(item, index) in product.data" :key="index" :value="item.id" :text="item.product_code"/>
                </vs-select>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label for class="vs-input--label">Client</label>
                <vs-select
                    class="selectExample"
                    v-model="data.client_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, client)"
                >
                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                </vs-select>
              </div>
            </div>
            <div class="vx-row mb-3 mt-1">
              <div class="vx-col w-full">
                <label for class="vs-input--label">Section *</label>
                <vs-select
                    class="selectExample"
                    v-model="data.section_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, section)"
                >
                    <vs-select-item v-for="(item, index) in section.data" :key="index" :value="item.id" :text="item.section_code"/>
                </vs-select>
              </div>
            </div>
            <br />
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <b>Blocking</b>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-checkbox v-model="data.pick_block">Pick Block</vs-checkbox>
                <!-- <vs-radio v-model.number="data.pick_block" vs-name="pick_block" vs-value="1">Pick Block</vs-radio> -->
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-checkbox v-model="data.put_block">Put Block</vs-checkbox>
                <!-- <vs-radio v-model.number="data.put_block" vs-name="put_block" vs-value="2">Put Block</vs-radio> -->
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/4 w-full">
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input
                  class="w-full"
                  label="Location Sequence "
                  v-model="data.location_squence"
                  @keypress="isNumber($event)"
                />
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input
                  class="w-full"
                  label="Cap. Volume"
                  v-model="data.cap_volume"
                  @keypress="isNumber($event)"
                  maxlength="5"
                />
                <div style="font-size: 8px; color:red;" class="vld"></div>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input
                  class="w-full"
                  label="Cap. Weight "
                  v-model="data.cap_weight"
                  @keypress="isNumber($event)"
                  maxlength="5"
                />
                <div style="font-size: 8px; color:red;" class="vld"></div>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input
                  class="w-full"
                  label="Cap. Storage Unit"
                  v-model="data.cap_storage_unit"
                  @keypress="isNumber($event)"
                  maxlength="5"
                />
                <div style="font-size: 8px; color:red;" class="vld"></div>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <label for class="vs-input--label">Warehouse</label>
                <vs-select
                  class="selectExample"
                  v-model="data.warehouse_id"
                  width="100%"
                  autocomplete
                  @input-change="searchDropdown($event, warehouse)"
              >
                  <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
              </vs-select>
              </div>
            </div>
          </div>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    vSelect,
    flatPickr
  },
  data() {
    return {
      isLoading: false,
      data: {
        id: "",
        location_code: "",
        location_type_id: null,
        client_id: null,
        section_id: null,
        location_squence: "",
        cap_volume: "",
        cap_weight: "",
        cap_storage_unit: "",
        warehouse_id: null,
        dedicated_product_id: null,
        pick_block: "",
        put_block: ""
      },
      locationTypeOptions: [],
      dedicatedProductOptions: [],
      clientOptions: [],
      sectionOptions: [],
      warehouseOptions: [],
      location_type: {
        data: [],
        loading: false,
        endpoint: 'master/locationtypes',
        objectKey: 'code'
      },
      product: {
        data: [],
        loading: false,
        endpoint: 'master/product',
        objectKey: 'product_code'
      },
      client: {
        data: [],
        loading: false,
        endpoint: 'master/clients',
        objectKey: 'client_code'
      },
      section: {
        data: [],
        loading: false,
        endpoint: 'master/sections',
        objectKey: 'section_code'
      },
      warehouse: {
        data: [],
        loading: false,
        endpoint: 'master/warehouses',
        objectKey: 'warehouses_code'
      },
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    }
  },
  methods: {
    submitForm() {
      this.isLoading = true;
      if (this.data.put_block) {
        this.data.put_block = 1;
      } else {
        this.data.put_block = 0;
      }
      if (this.data.pick_block) {
        this.data.pick_block = 1;
      } else {
        this.data.pick_block = 0;
      }
      this.$http
        .post("master/locations/store", this.data)
        .then(res => {
          this.$vs.notify({
            color: "success",
            title: "Saved Successfully",
            iconPack: "feather",
            icon: "icon-check",
            text: "location added"
          });
          this.$router.push({ path: "/master/location" });
        })
        .catch(error => this.handleError(error))
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    back() {
      if (
        this.data.location_code != "" ||
        this.data.location_type_id != "" ||
        this.data.client_id != "" ||
        this.data.section_id != "" ||
        this.data.location_squence != "" ||
        this.data.cap_volume != "" ||
        this.data.cap_weight != "" ||
        this.data.cap_storage_unit != "" ||
        this.data.warehouse_id != ""
      ) {
        this.$vs.dialog({
          color: "warning",
          title: "Leave Page",
          text: "Changes you made may not be saved?",
          acceptText: "Leave Page",
          accept: () => this.$router.go(-1)
        });
      } else {
        this.$router.go(-1);
      }
    },
    fetchAllData() {
      this.isLoading = true;
      Promise.all([
          this.$http.post("master/locationtypes"),
          this.$http.post("master/product"),
          this.$http.post("master/clients"),
          this.$http.post("master/sections"),
          this.$http.post("master/warehouses"),
      ]).then(this.$http.spread((locationtypes, products, clients, sections, warehouses) => {
        locationtypes.data.data.map(location_type => {
            if(this.location_type.data.findIndex(a => a.id == location_type.id) === -1) {
                this.location_type.data.push(location_type)
            }
        })

        products.data.data.map(product => {
            if(this.product.data.findIndex(a => a.id == product.id) === -1) {
                this.product.data.push(product)
            }
        })

        clients.data.data.map(client => {
            if(this.client.data.findIndex(a => a.id == client.id) === -1) {
                this.client.data.push(client)
            }
        })

        sections.data.data.map(section => {
            if(this.section.data.findIndex(a => a.id == section.id) === -1) {
                this.section.data.push(section)
            }
        })

        warehouses.data.data.map(warehouse => {
            if(this.warehouse.data.findIndex(a => a.id == warehouse.id) === -1) {
                this.warehouse.data.push(warehouse)
            }
        })
        this.isLoading = false
      }))
        .catch(() => {
          this.isLoading = false;
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: "Server Error",
            text: "Try again?",
            accept: () => {
              this.fetchAllData();
            },
            cancel: () => this.$router.go(-1),
            acceptText: "Yes",
            cancelText: "No"
          });
          return;
        });
    }
  },
  mounted() {
    this.fetchAllData();
  }
};
</script>